<template xmlns="">
  <div>
    <div class="sr-comInfo">
      <div class="sr-layout-wrap">

        <el-image src="https://sara-infinity.com/logo.jpg" style="float: left; height: 10%;width: 10%"  />

        <div class="sr-comInfo-r" style="margin-top: 3%;margin-left: 3%">
          <div class="sr-comInfo-title J-title-comName">
            <div class="title-txt">
              <a href="https://www.sara-infinity.com">
                <h1 style="font-size: 22px">
                  GUANGZHOU ZHIZHEN VEHICLE PARTS CO.,LTD.<i class="ob-icon icon-down"></i>
                </h1>
              </a>
            </div>

          </div>
          <div class="sr-comInfo-sign">
            <div class="sign-item">
              <i class="el-icon-message"></i> <span class="txt-year">525205929@qq.com</span>
              <div class="tip arrow-top tip-gold">
                <div class="tip-con">
                  <p class="tip-para">Suppliers with verified business licenses</p>
                </div>
                <span class="arrow arrow-out">
                                    <span class="arrow arrow-in"></span>
                                </span>
              </div>
            </div>
            <div class="sign-item as-logo" data-title="Audited by an independent third-party inspection agency">
              <i class="el-icon-phone"></i>
              <span class="txt-year">+86 18680557608</span>
            </div>
          </div>
        </div>
      </div>
    </div>


    <el-menu
        default-active="2"
        class="el-menu-demo"
        mode="horizontal"
        background-color="#545c64"
        text-color="#fff"
        active-text-color="#ffd04b"
        style="padding-left: 21.2%">
      <el-menu-item index="1"><router-link to="/home" >Home</router-link></el-menu-item>
      <el-menu-item index="2"><router-link to="/products" >Products</router-link></el-menu-item>
      <el-menu-item index="3" ><router-link to="/aboutUs" >About Us</router-link></el-menu-item>
      <el-menu-item index="4" disabled><router-link to="" >Solutions</router-link></el-menu-item>
      <el-menu-item index="5"><router-link to="/sendUs" >Send Us</router-link></el-menu-item>
    </el-menu>


    <div class="sr-layout-wrap sr-layout-resp" style="margin-top: 2%">



      <div class="sr-layout-nav prodlist-page-nav J-prodlist-page-nav">
        <div class="J-prod-menu-bg prod-menu-bg"></div>
        <div class="sr-layout-block prod-menu">
          <div class="sr-layout-subblock sr-side-searchBar">

              <input class="input-text sr-side-searchBar-input" type="text" name="searchKeyword" id="keyWord" placeholder="Search Products" value=""/>
              <input type="hidden" id="viewType" name="viewType" value="1"/>
              <button class="sr-side-searchBar-button" id="SearchForm"  >
                <i class="ob-icon icon-search"></i>
              </button>

          </div>
          <div class="sr-layout-subblock sr-side-proGroup" faw-module="Prod_group_filter" faw-exposure>
            <div class="sr-txt-title">
              <h2 class="sr-txt-h2">Product Groups</h2>
            </div>
            <ul class="sr-side-proGroup-list">
              <li   v-for="(item, index) in list" :key="index">
                <a ref="nofollow"  :title="item.title" ads-data="">{{item.title}}</a>
              </li>

            </ul>
          </div>

<!--          <div class="sr-layout-subblock sr-side-proGroup-cat">-->
<!--            <a class="pro-catalogs" ref="nofollow" ><i class="ob-icon icon-pdf"></i>Product Catalogs</a>-->
<!--          </div>-->
        </div>

      </div>






      <!----------------------------------------------------------------------right---------------------------------------------------------------------------------------->





      <div class="sr-layout-main prodlist-page-main">
        <div class="sr-layout-block ">
          <div class="sr-layout-subblock prod-result">

            <div class="cf prod-list-title">
              <div itemscope itemtype="" class="sr-txt-title">
                <h1 class="sr-txt-h2">All Products</h1>
              </div>
            </div>


            <div class="sr-layout-content">
              <div class="prod-result-list prod-gallery-list cf">


                <div   v-for="(item, index) in data" :key="index" class="prod-result-item J-prod-result-item" faw-module="Prod_list" faw-exposure="" data-prodid="mdpawoPrgufX" data-prod-tag=""  faw-id="1hnndr5t059f">
                  <div class="prod-item-inner">
                    <div class="prod-image ">
                      <a  >
                        <img class="J-prod-gif-pic" :src="addr+item.img"  :alt="item.title" style="display: block;">
                      </a>
                    </div>
                    <div class="prod-info">
                      <div class="prod-title">
                        <a  :title="item.title" >
                         {{item.title}}
                        </a>
                      </div>
                      <div class="prod-price" :title="item.Price">
                        <span class="label">FOB Price:</span> <span class="value"> {{item.Price}} </span><span class="unit">/ Set</span>
                      </div>
                      <div class="min-order" title="Min. Order: 100 Sets">
                        <span class="label">Min. Order:</span> <span class="value">100 Sets </span>
                      </div>
                    </div>
                    <button  @click="sendMessageOpen(item.img)" class="btn" style="width: 100%">Contact Now</button>
                  </div>
                </div>



              </div>
              <div class="sr-prod-quick-view J-quick-view-container">
                <div class="sr-prod-quick-view-bg"></div>
                <div class="sr-layout-content sr-proMainInfo">
                  <div class="sr-prod-quick-view-close J-prod-quick-view-close"><i class="ob-icon icon-delete"></i></div>
                  <div class="J-quick-view-content sr-prod-quick-view-content"></div>
                  <div class="J-quick-view-loading sr-prod-quick-view-loading"></div>
                </div>
              </div>
            </div>
            <div class="prod-result-footer">

              <div class="pager">
                <div class="page-num">
                  <span title="Go to Previous Page"><a class="prev disClick" rel="nofollow"><i class="ob-icon icon-left"></i></a></span>
                  <span class="current">1</span>
                  <a  rel="nofollow">2</a>
                  <a  rel="nofollow">3</a>
                  <a  rel="nofollow">4</a>
                  <a  rel="nofollow">5</a>
                  <a  rel="nofollow">6</a>
                  <a  rel="nofollow">7</a>
                  <a  rel="nofollow">8</a>
                  <span class="dot"><i class="ob-icon icon-more"></i></span>
                  <span title="Go to Next Page">
            <a class="next page-main" rel="nofollow" >Next<i class="ob-icon icon-right"></i></a>
          </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>















    </div>


    <!-----------------------------------------------------------------------------------底部------------------------------------------------------------------------->
    <div class="m-footer pad-footer m-sr-footer">
      <div class="grid">
        <div class="m-footer-simple-links pad-footer-simple">
          <div class="m-footer-simple-links-group pad-footer-hide">
            <div class="m-footer-simple-links-row">
              <a>{{language?"热门产品":"Hot Products"}}</a>
              <span class="m-gap-line"></span>
              <a>{{language?"中国产品":"China Products"}}</a>
              <span class="m-gap-line"></span>
              <a>{{language?"中国制造商/供应商":"Chinese Manufacturers/Suppliers"}}</a>
              <span class="m-gap-line"></span>
              <a>{{language?"中国批发":"China Wholesale"}}</a>
              <span class="m-gap-line"></span>
              <a>{{language?"批发价格":"Wholesale Price"}}</a>
              <span class="m-gap-line"></span>
              <a>{{language?"行业网站":"Industry Sites"}}</a>
              <span class="m-gap-line"></span>
              <a>{{language?"区域渠道":"Regional Channels"}}</a>
              <span class="m-gap-line"></span>
              <a>{{language?"产品指数":"Product Index"}}</a>

            </div>

          </div>
          <div class="m-footer-simple-links-group pad-footer-oneline">
            <div class="m-footer-simple-links-row m-footer-copyright">
              Copyright &copy; 2023-2024 <a class="J-focusChinaLink" href="https://www.sara-infinity.com/"
                                            rel="nofollow"
                                            target="_blank">{{language?"广州至臻机车配件有限公司":"GUANGZHOU ZHIZHEN VEHICLE PARTS CO.,LTD."}}</a>&nbsp;{{language?"保留所有权利":"All Rights Reserved."}}

            </div>
            <span class="m-gap-line"></span>
            <div class="m-footer-simple-links-row">
              <a rel="nofollow" target="_self">{{language?"保留所有权利":"User Agreement"}}</a>
            </div>
          </div>
          <div style="display: flex;justify-content: center;width: 100%">

            <div class="m-footer-simple-links-row m-footer-govIcon pad-hide" style="color: blue" >
              <a href="https://beian.mps.gov.cn/#/query/webSearch?code=44011102483772" rel="noreferrer" target="_blank"><i class="m-ico m-ico-police-new"></i>粤公网安备44011102483772</a>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              <a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank" data-v-644aa589="" style="margin-left: 20px;">粤ICP备2024199978号</a>
            </div>
          </div>
        </div>
      </div>
    </div>




    <el-dialog center
               :visible.sync="sendMessageDialog"
               :close-on-click-modal="false"
               @close="closeDialog"
               width="50%">



      <div class="sr-layout-block J-msg-block" faw-module="supplier_inquiry" faw-exposure>
        <div class="sr-txt-title">
          <h2 class="sr-txt-h2">Send your message to this supplier</h2>
        </div>
        <div class="sr-layout-content sr-sendMsg">
          <div class="sr-sendMsg-form obelisk-form">

            <div class="sr-sendMsg-row">
              <div class="sr-sendMsg-label">
                <em>*</em>From:
              </div>
              <div class="sr-sendMsg-field J-quick-inquiry-email-wrap">
                <input class="input-text sr-sendMsg-input" name="senderMail" type="text"
                       placeholder="Enter your email address" value=""/>
              </div>
            </div>
            <div class="sr-sendMsg-row">
              <div class="sr-sendMsg-label">
                <em>*</em>To:
              </div>
              <div class="sr-sendMsg-field">

                <span class="sr-sendMsg-name">Ms. zhang</span>
              </div>
            </div>
            <div class="sr-sendMsg-row">
              <div class="sr-sendMsg-label">
                <em>*</em>Message:
              </div>
              <div class="sr-sendMsg-field">
                      <textarea class="input-textarea sr-sendMsg-area" name="content" id="inquiryContent" cols="90"
                                rows="5"
                                placeholder="We suggest you detail your product requirements and company information here."
                                maxlength="4000"></textarea>
                <p class="sr-sendMsg-tips">Enter between 20 to 4,000 characters.</p>
              </div>
            </div>
            <div class="">
              <div class="sr-sendMsg-label"></div>
              <div class="sr-sendMsg-field">
                <div id="captcha" style="float:left;"></div>
                <input type="hidden" name="hmToken" class="J-hmToken" value=""/>
                <input type="hidden" class="J-hmCaptchaId" value="18bd4c8e-230c-435c-9a1d-cb9309d80086"/>
              </div>
            </div>
            <div class="sr-sendMsg-row">
              <div class="sr-sendMsg-field">

                <button fun-inquiry-supplier  class="btn btn-main sr-sendMsg-btn" id="inquirySend" @click="send()" >Send
                </button>
                <span class="sr-sendMsg-promote">This is not what you are looking for?</span>

              </div>
            </div>

          </div>
        </div>
      </div>



    </el-dialog>



  </div>
</template>

<script>
export default {
  data() {
    return {
      localImage: require('@/assets/img/logo.jpg'),
      sendMessageDialog:false,
      addr:"https://sara-infinity.com/",
      list: [ {
        title:"Motorcycle Cylinder Kits For HONDA",href:""},
        { title:"Motorcycle Cylinder Kits For YAMAHA",href:""},
        { title:"Motorcycle Cylinder Kits For SUZUKI",href:""},
        { title:"Motorcycle Cylinder Kits For BAJAJ",href:""},
        { title:"Motorcycle Cylinder Kits For PIAGGIO",href:""},
        { title:"Motorcycle Cylinder Kit For HERO",href:""},
        { title:"Motorcycle Cylinder Kits For TVS",href:""},
        { title:"Motorcycle Bigbore Racing Cylinder Kits",href:""},
        { title:"Motorcycle Engine",href:""},
        { title:"Motorcycle Piston Ring Kit",href:""},
        { title:"Motorcycle Gasket",href:""},
        { title:"Motorcycle Spark Plug",href:""},
        { title:"Motorcycle Carburetor",href:""},
        { title:"Chainsae &amp; Grasscutter Cylinder Kits",href:""},
        { title:"Outboard Engine Cylinder Liner Sleeve",href:""},
        { title:"Other Motorcycle Cylinder Kits",href:""}
      ],
      data:[
        {
          title:"Trkimal 52.4mm Engine Parts Cylinder big bore kits with Gaskets and Piston Set for 4 Stroke Chinese TaoTao Coolster ATV 110cc Pit Quad Dirt Bike Go Kart",
          alt:"",
          href:"",
          img:"1.png",
          Price:"US $30-60",

        },{
          title:"Cylinder Piston Gasket Kit 250cc CG250 Chinese ATV Dirt Bike Engine Cylinder Kit Cylinder Piston Gasket Fits Cg250 250cc Air Cooled Vertical Engine Air Cooled Engine ATV Quad Bike Go Kart Cylinder Kit",
          alt:"",
          href:"",
          img:"2.png",
          Price:"US $50-80 ",

        },{
          title:"DENEST Cylinder Gasket Piston Rings Set Top End Rebuild Kit Compatible for 2000-2006 Honda Rancher 350 TRX350 4x4",
          alt:"",
          href:"",
          img:"3.png",
          Price:"US $55-73",

        },{
          title:"Engine Piston Kit, Metal Piston Rings Gasket Set For 110cc 125cc ATV Dirt Pit Bike Go Kart",
          alt:"",
          href:"",
          img:"4.png",
          Price:"US $15-18",

        },{
          title:"Lumix GC Gasket Piston Clip Cylinder For KAZUMA Meerkat Redcat 50 ATV QUAD 50CC",
          alt:"",
          href:"",
          img:"5.png",
          Price:"US $45-48",

        },{
          title:"54mm Big Bore Kit for Honda Dirt Bike ATV - Convert 110cc to 125cc Cylinder Piston Ring Gasket Set",
          alt:"",
          href:"",
          img:"6.png",
          Price:"US $39-60 ",

        },{
          title:"250cc Cylinder Piston Gasket Kit 67mm CG250 167FMM Chinese ATV Dirt Bike TaoTao",
          alt:"",
          href:"",
          img:"7.png",
          Price:"US $60-80",

        },{
          title:"ZhdnBhnos 67mm Big Bore Cylinder Piston Gasket Kit for CG250 250cc Air Cooled Vertical Engine ATV Quad Go Kart Dirt Pit Bike",
          alt:"",
          href:"",
          img:"8.png",
          Price:"US $60-72",

        },{
          title:"Trkimal GY6 150cc 57.4mm Bore Cylinder kit with Piston Kit 4 Stroke 152QMI 157QMJ for TAOTAO JONWAY ZNEN Roketa ATV Moped Go-Kart",
          alt:"",
          href:"",
          img:"9.png",
          Price:"S $30-40",

        },{
          title:"Cylinder Gasket Piston Top End Replacement for 1992-2000 Yamaha Timberwolf 250 YFB250 4BD-11310-01-00",
          alt:"",
          href:"",
          img:"10.png",
          Price:"US $80",

        },{
          title:"SEBLAFF Cylinder Piston Top End Rebuild Kit For Honda Recon 250 TRX250 TRX250EX",
          alt:"",
          href:"",
          img:"11.png",
          Price:"US $95",

        },
        {
          title:"Farmertec 52mm Cylinder Piston Kit WT Pin Ring Circlip Compatible with Stihl MS461 R/RZ/Z/Magnum Chainsaw 1128 020 1250",
          alt:"",
          href:"",
          img:"0.png",
          Price:"US $40-70",

        },
        {
          title:"SIZE TYPE P.R. 2.50-17 T/T 4/6/8 2.50-18 T/T 4/6/8 2.75-17 T/T 4/6/8 2.75-18 T/T 4/6/8 3.00-17 T/T 4/6/8 3.00-18 T/T 4/6/8",
          alt:"SY-M001",
          href:"",
          img:"12.png",
          Price:"US $15-18",

        },{
          title:"SIZE TYPE P.R. 2.75-14 T/T 4/6/8 2.50-17 T/T 4/6/8 2.75-17 T/T 4/6/8 2.50-18 T/T 4/6/8 2.75-18 T/T 4/6/8 3.00-18 T/T&T/L 4/6/8",
          alt:"SY-M002",
          href:"",
          img:"13.png",
          Price:"US $12-15",

        },{
          title:"SIZE TYPE P.R. 2.25-17 T/T 4/6/8 2.50-17 T/T 4/6/8 2.50-18 T/T 4/6/8 2.75-18 T/T&T/L 4/6/8",
          alt:"SY-M003",
          href:"",
          img:"14.png",
          Price:"US $9-10 ",

        },{
          title:"SIZE TYPE P.R. 3.25-16 T/T 4/6/8 3.25-18 T/T&T/L 4/6/8 110/90-16 T/T&T/L 59P/65P",
          alt:"SY-M004",
          href:"",
          img:"15.png",
          Price:"US $12-13",

        },{
          title:"90/90-18 T/T&T/L 51P/57P",
          alt:"SY-M005",
          href:"",
          img:"16.png",
          Price:"US $15-18",

        },{
          title:"2.25-17 T/T 4/6/8 2.75-18 T/T&T/L 4/6/8 3.00-18 T/T 4/6/8",
          alt:"SY-M006",
          href:"",
          img:"17.png",
          Price:"US $6-10",

        },{
          title:"3.00-18 T/T 4/6/8 2.75-14 T/T 4/6/8",
          alt:"SY-M008",
          href:"",
          img:"18.png",
          Price:"US $30-35 ",

        },{
          title:"SY-MOO9 规格：3.00-18 T/T&T/L 4/6/8PR",
          alt:"SY-M009",
          href:"",
          img:"19.png",
          Price:"US $9-11",

        },{
          title:"SY-M011 规格型号：3.00-18 T/T 4/6/8PR",
          alt:"SY-M0011",
          href:"",
          img:"20.png",
          Price:"US $38-40",

        },{
          title:"SY-M018 SIZE 3.25-16 P.R. 4/6/8PR C TT",
          alt:"SY-M0018",
          href:"",
          img:"21.png",
          Price:"S $20",

        },{
          title:"SY-M019 60/90-17 T/T&T/L 30P/36P 70/90-17 T/T&T/L 38P/43P 80/90-17 T/L 44P/50P 90/80-17 46P/52P 110/70-17 T/L 54P 140/70-17 T/L 66P/72P",
          alt:"SY-M0019",
          href:"",
          img:"22.png",
          Price:"US $11-12",

        },{
          title:"SY-M022 规格型号： 3.00-17 T/T 4/6/8PR 3.00-18 T/T 4/6/8PR",
          alt:"SY-M0022",
          href:"",
          img:"23.png",
          Price:"US $22-25",

        },
      ]
    }
  },
  methods: {

    sendMessageOpen(data) {
      let that = this
      that.sendMessageDialog =true

    },
    closeDialog() {
      let that = this
      that.sendMessageDialog =false

    },

    send() {
      this.$message.success("Successfully");
      this. closeDialog()

    },


    isIE() {
      if (window.ActiveXObject || "ActiveXObject" in window) {
        this.$message.info('ie浏览器不兼容！')
        return true;
      }
      return false;
    },
  },

  mounted() {

    if (this.isIE()) {
      this.$confirm('此平台不兼容ie浏览器，使用ie浏览器可能会出现未知错误', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {

      });
    }


  }
}
</script>

<style scoped>
.catalogForm .form-label {
  width: 190px;
}

.catalogForm .form-label em {
  color: #e64545;
  margin-right: 5px;
}

.catalogForm .form-fields {
  margin-left: 200px;
}

.shipping-cost-tm .tm-status-off {
  background: none;
  padding: 0;
  color: #1470cc
}

</style>
